import React from "react";

export const DropDownButtonMobile = ({
  dropDownCss,
  headingText,
  orderText,
  divClass,
  insideText,
  bottomText,
  displayDropDown,
  onClick,
  extraStyles
}) => {
  return (
    <React.Fragment>
        <div style={{fontFamily:"Roboto-Regular",}}>
        <p className="f14-500">{headingText}</p>
        <div className={dropDownCss} onClick={onClick} style={extraStyles}>
        
        <div className={divClass} >
          {orderText ? (
            <h5 className="f12-500 mb-0 mr-2" style={extraStyles}>{insideText}</h5>
          ) : (
            <h5 style={{ paddingRight: "15px" }}>{insideText}</h5>
          )}
          {displayDropDown === true ? (
            <i className="fa fa-angle-down drop-icon-white"></i>
          ) : (
            <i className="fa fa-angle-down drop-icon-white ml-2"></i>
          )}
        </div>
        {bottomText && (
          <p style={{ paddingTop: "5px" }}>
            <center>{bottomText}</center>
          </p>
        )}
      </div>
      </div>
    </React.Fragment>
  );
};

export const DropDownBoxCrret = ({ state, showText, hideText, onClick }) => {
  return (
    <React.Fragment>
      <button className="map-dropdown-button" onClick={onClick} type="button">
        {state ? showText : hideText}
        {state ? (
          <i className="fa fa-chevron-up" aria-hidden="true"></i>
        ) : (
          <i className="fa fa-chevron-down" aria-hidden="true"></i>
        )}
      </button>
    </React.Fragment>
  );
};
